module.exports = __webpack_public_path__ + "media/Schamanz_loop.fe18bbdd.mp4";